import { render, staticRenderFns } from "./ShippingAddress.vue?vue&type=template&id=1d5b8954&"
import script from "./ShippingAddress.vue?vue&type=script&lang=ts&"
export * from "./ShippingAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports